import Markdown from "./Markdown";
import Resources from "./Resources";
import TableOfContents from "./TableOfContents";
import Texts from "./Texts";
import Metadata from "./Metadata";
import RecentActivity from "./RecentActivity";

export default {
  Markdown,
  Resources,
  TableOfContents,
  Texts,
  Metadata,
  RecentActivity
};
